import { useState, useEffect } from "react";
import EducationPage from "../pages/EducationPage";
import MemberPage from "../pages/MemberPage";
import CarePage from "../pages/CarePage";
import EducationApplyPage from "../pages/EducationApplyPage";
import AttendancePage from "../pages/AttendancePage";
import AccountingPage from "../pages/AccountingPage";
import CodePage from "../pages/CodePage";
import GiftPage      from "../pages/GiftPage";
import GiftApplyPage from "../pages/GiftApplyPage";
import JoinApprovalPage from "../pages/JoinApprovalPage";
import NoticePage from "../pages/NoticePage";
import { updateDivisionSettings } from "../api/branchApi";
import { fetchActiveNotices, markNoticeRead } from "../api/noticeApi";
import ChangePasswordModal from "../components/ChangePasswordModal";
import MentimeterPage from "../pages/MentimeterPage";
import AdminBoardPage from "../pages/AdminBoardPage";
import SurveyPage from "../pages/SurveyPage";
import SurveyMemberPage from "../pages/SurveyMemberPage";
import { resolveImageUrl } from "../utils/resolveImageUrl";
import kptuLogo from "../assets/kptulogo.png";  // ← 추가
import CareWorkPage from "../pages/CareWorkPage"; 

const ROOT_MENUS = [ // 메뉴가 너무 많아 화면에 전부 표시할 수 없어 이름 단축함 실제 메뉴는 주석 참고
  { key: "member",        label: "관리",     icon: "👥" },  // 조합원관리
  { key: "join_approval", label: "승인",     icon: "📋" },  // 가입승인
  { key: "education",     label: "교육",     icon: "📚" },  // 교육
  { key: "attendance",    label: "출석",     icon: "✅" },  // 출석부
  { key: "gift",          label: "선물",     icon: "🎁" },  // 선물
  { key: "care",          label: "일지",     icon: "🏥" },  // 간병일지
  { key: "work",          label: "출근",     icon: "🗓️" },  // 출근부
  { key: "accounting",    label: "회계",     icon: "💰" },  // 간편회계
  { key: "mentimeter",    label: "생각",     icon: "📊" },  // 생각나눔
  { key: "survey",        label: "설문",     icon: "📝" },  // 설문조사
  { key: "notice",        label: "공지",     icon: "📢" },  // 공지사항
  { key: "board",         label: "보수",     icon: "📌" },  // 유지보수
  { key: "code",          label: "코드",     icon: "⚙️" },  // 공통코드
];

const ADMIN_MENUS = [
  { key: "member",        label: "조합원관리",   icon: "👥" },
  { key: "join_approval", label: "가입승인",     icon: "📋" },
  { key: "education",     label: "교육",        icon: "📚" },
  { key: "attendance",    label: "출석부",      icon: "✅" },
  { key: "gift",          label: "선물",        icon: "🎁" },
  { key: "mentimeter",    label: "생각나눔",     icon: "📊" },
  { key: "survey",        label: "설문조사",     icon: "📝" },
  { key: "notice",        label: "공지사항",     icon: "📢" },
  { key: "board",         label: "유지보수",     icon: "📌" },
];

const ADMINCARE_MENUS = [
  { key: "member",        label: "조합원관리",    icon: "👥" },
  { key: "care",          label: "간병일지",      icon: "🏥" },
  { key: "work",          label: "출근부",        icon: "🗓️" },
  { key: "accounting",    label: "간편회계",      icon: "💰" },
  { key: "board",         label: "유지보수",      icon: "📌" },
];

const MEMBER_MENUS = [
  { key: "notice",          label: "공지사항",     icon: "📢" },
  { key: "education_apply", label: "교육신청",     icon: "📝" },
  { key: "gift_apply",      label: "선물신청",     icon: "🎀" },
  { key: "survey_apply",    label: "설문조사",     icon: "📋" },
];

export default function Layout({ onLogout, userLevel }) {

  const isRoot  = userLevel === '0';
  const isAdminCare = ['3'].includes(userLevel); // 간병 관리자(메뉴 정리용)
  const isAdmin     = ['0', '1'].includes(userLevel) || isAdminCare;  // ← 여기서 합치기
  const menus       = isRoot ? ROOT_MENUS : isAdminCare ? ADMINCARE_MENUS : isAdmin ? ADMIN_MENUS : MEMBER_MENUS; // 순서변경금지

  const [activeMenu, setActiveMenu] = useState(isAdmin ? "member" : "education_apply");
  const [notices,      setNotices]      = useState([]);
  const [noticeIdx,    setNoticeIdx]    = useState(0);
  const [showNotice,   setShowNotice]   = useState(false);
  const [imageZoom,    setImageZoom]    = useState(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isMobile,       setIsMobile]       = useState(window.innerWidth <= 768);

  const user         = JSON.parse(localStorage.getItem("user") || "{}");
  const divisionName = user.division_name || "의료연대본부";
  const divisionPhone = user.division_phone || '';
  const [showPhoneModal, setShowPhoneModal] = useState(false);
  const [phoneInput,     setPhoneInput]     = useState('');
  const [sealPreview,    setSealPreview]    = useState(user.seal_img || '');
  const [sealImg,        setSealImg]        = useState('');
  const [showChangePw, setShowChangePw] = useState(false);

  // 화면 크기 감지
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // 공지사항
  useEffect(() => {
    if (isAdmin) return;
    const loadNotices = async () => {
      try {
        const res = await fetchActiveNotices();
        if (res.success && res.data.length > 0) {
          setNotices(res.data);
          setNoticeIdx(0);
          setShowNotice(true);
        }
      } catch (err) {}
    };
    loadNotices();
  }, []);

  const handleMenuClick = (key) => {
    setActiveMenu(key);
    setMobileMenuOpen(false);
  };

  // 뒤로가기 완전 차단
  useEffect(() => {
    // 초기 히스토리 추가
    window.history.pushState(null, '', window.location.pathname);

    const handlePopState = () => {
      // 뒤로가기 시 항상 현재 위치로 다시 push (차단)
      window.history.pushState(null, '', window.location.pathname);
    };

    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  const renderPage = () => {
    switch (activeMenu) {
      case "member":          return <MemberPage onLogout={onLogout} userLevel={userLevel} />;
      case "join_approval":   return <JoinApprovalPage onLogout={onLogout} />;
      case "education":       return <EducationPage onLogout={onLogout} userLevel={userLevel} />;
      case "education_apply": return <EducationApplyPage onLogout={onLogout} />;
      case "attendance":      return <AttendancePage onLogout={onLogout} userLevel={userLevel} />;
      case "gift":            return <GiftPage onLogout={onLogout} />;
      case "gift_apply":      return <GiftApplyPage onLogout={onLogout} />;
      case "care":            return <CarePage onLogout={onLogout} userLevel={userLevel} />;
      case "work":            return <CareWorkPage onLogout={onLogout} userLevel={userLevel} />;
      case "accounting":      return <AccountingPage onLogout={onLogout} />;
      case "notice":          return <NoticePage onLogout={onLogout} isAdmin={isAdmin} />;
      case "mentimeter":      return <MentimeterPage />;
      case "survey":          return <SurveyPage />;
      case "survey_apply":    return <SurveyMemberPage onLogout={onLogout} />;
      case "code":            return <CodePage />;
      case "board":           return <AdminBoardPage />;
      default:                return null;
    }
  };

  return (
    <div style={styles.wrap}>
      <header style={styles.header}>
        <div style={styles.headerInner}>

          {/* 로고 */}
          <div style={styles.logo}>
            <img src={kptuLogo} alt="노조 로고" style={styles.logoIcon} />
            <span
              style={{
                ...styles.logoText,
                cursor: isAdmin ? "pointer" : "default",
                textDecoration: isAdmin ? "underline dotted rgba(255,255,255,0.4)" : "none"
              }}
              onClick={() => {
                if (!isAdmin) return;
                setPhoneInput(divisionPhone);
                setSealPreview(user.seal_img || '');
                setSealImg('');
                setShowPhoneModal(true);
              }}
              title={isAdmin ? "클릭하여 전화번호 수정" : ""}
            >
              {divisionName}
            </span>
          </div>

          {/* 데스크탑 메뉴 */}
          {!isMobile && (
            <nav style={styles.nav}>
              {menus.map(menu => (
                <button key={menu.key}
                  style={{ ...styles.navBtn, ...(activeMenu === menu.key ? styles.navBtnActive : {}) }}
                  onClick={() => handleMenuClick(menu.key)}>
                  {menu.icon} {menu.label}
                </button>
              ))}
            </nav>
          )}

          {/* 우측 - 데스크탑 유저 정보 */}
          {!isMobile && (
            <div style={styles.userArea}>
              <span
                style={{ ...styles.userName, cursor: "pointer", textDecoration: "underline dotted rgba(255,255,255,0.4)" }}
                onClick={() => setShowChangePw(true)}
                title="클릭하여 비밀번호 변경"
              >👤 {user.name || "사용자"}</span>
              {isRoot  && <span style={{ ...styles.adminBadge, background: "#722ed1" }}>루트</span>}
              {!isRoot && isAdmin && <span style={styles.adminBadge}>관리자</span>}
              <button style={styles.logoutBtn} onClick={onLogout}>로그아웃</button>
            </div>
          )}

          {/* 모바일 우측 - 현재 메뉴명 + 햄버거 */}
          {isMobile && (
            <div style={{ display: "flex", alignItems: "center", gap: 10, marginLeft: "auto" }}>
              <span style={{ fontSize: 13, color: "rgba(255,255,255,0.8)", fontWeight: 600 }}>
                {menus.find(m => m.key === activeMenu)?.icon} {menus.find(m => m.key === activeMenu)?.label}
              </span>
              <button
                style={styles.hamburger}
                onClick={() => setMobileMenuOpen(p => !p)}>
                {mobileMenuOpen ? "✕" : "☰"}
              </button>
            </div>
          )}
        </div>

        {/* 모바일 드롭다운 메뉴 */}
        {isMobile && mobileMenuOpen && (
          <div style={styles.mobileMenu}>
            {menus.map(menu => (
              <button key={menu.key}
                style={{ ...styles.mobileMenuItem, ...(activeMenu === menu.key ? styles.mobileMenuItemActive : {}) }}
                onClick={() => handleMenuClick(menu.key)}>
                {menu.icon} {menu.label}
              </button>
            ))}
            <div style={styles.mobileUserInfo}>
              <span style={{ fontSize: 13, color: "rgba(255,255,255,0.7)" }}
                onClick={() => setShowChangePw(true)}>
                👤 {user.name || "사용자"} 
                {isRoot && <span style={{ ...styles.adminBadge, background: "#722ed1" }}>루트</span>}
                {!isRoot && isAdmin && <span style={styles.adminBadge}>관리자</span>}
              </span>
              <button style={styles.logoutBtn} onClick={onLogout}>로그아웃</button>
            </div>
          </div>
        )}
      </header>

      <main style={styles.main}>
        {renderPage()}
      </main>

      {/* 분회설정 수정 모달 */}
      {/* 분회별 설정 모달 */}
      {showPhoneModal && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", zIndex: 200, display: "flex", alignItems: "center", justifyContent: "center" }}>
          <div style={{ background: "#fff", borderRadius: 16, width: "100%", maxWidth: 460, margin: "0 16px", boxShadow: "0 20px 60px rgba(0,0,0,0.3)", overflow: "hidden" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "20px 24px", borderBottom: "1px solid #f0f0f0" }}>
              <h3 style={{ fontSize: 16, fontWeight: 700, color: "#1a1a2e", margin: 0 }}>⚙️ 분회별 설정</h3>
              <button style={{ background: "none", border: "none", fontSize: 18, color: "#aaa", cursor: "pointer" }}
                onClick={() => setShowPhoneModal(false)}>✕</button>
            </div>
            <div style={{ padding: "24px", display: "flex", flexDirection: "column", gap: 20 }}>
              <div style={{ fontSize: 13, color: "#888", fontWeight: 600 }}>{divisionName}</div>

              {/* 전화번호 */}
              <div>
                <label style={{ fontSize: 13, fontWeight: 600, color: "#444", display: "block", marginBottom: 6 }}>📞 문의 전화번호</label>
                <input
                  style={{ width: "100%", border: "1.5px solid #e0e0e0", borderRadius: 8, padding: "10px 12px", fontSize: 14, outline: "none", boxSizing: "border-box" }}
                  value={phoneInput}
                  onChange={e => setPhoneInput(e.target.value)}
                  placeholder="예) 053-200-5116"
                  maxLength={50}
                />
              </div>

              {/* 직인 이미지 */}
              <div>
                <label style={{ fontSize: 13, fontWeight: 600, color: "#444", display: "block", marginBottom: 6 }}>🔏 직인 이미지 (PNG, 1MB 이하)</label>
                <input type="file" accept="image/png,image/jpeg,image/gif"
                  onChange={e => {
                    const file = e.target.files[0];
                    if (!file) return;
                    if (file.size > 1024 * 1024) { alert('이미지는 1MB 이하만 업로드 가능합니다.'); return; }
                    const reader = new FileReader();
                    reader.onload = ev => {
                      setSealImg(ev.target.result);
                      setSealPreview(ev.target.result);
                    };
                    reader.readAsDataURL(file);
                  }}
                />
                {sealPreview && (
                  <div style={{ marginTop: 10, display: "flex", alignItems: "center", gap: 12 }}>
                    <img src={sealPreview} alt="직인미리보기"
                      style={{ width: 80, height: 80, objectFit: "contain", border: "1px solid #e0e0e0", borderRadius: 8, background: "#fafafa" }} />
                    <button
                      style={{ fontSize: 12, color: "#ff4d4f", background: "none", border: "1px solid #ffccc7", borderRadius: 6, padding: "4px 10px", cursor: "pointer" }}
                      onClick={() => { setSealImg(''); setSealPreview(''); }}>
                      삭제
                    </button>
                  </div>
                )}
              </div>
            </div>

            <div style={{ display: "flex", gap: 10, justifyContent: "flex-end", padding: "0 24px 20px" }}>
              <button
                style={{ background: "#fff", border: "1px solid #e0e0e0", borderRadius: 8, padding: "10px 20px", fontSize: 14, color: "#666", cursor: "pointer" }}
                onClick={() => setShowPhoneModal(false)}>취소</button>
              <button
                style={{ background: "#1677ff", border: "none", borderRadius: 8, padding: "10px 20px", fontSize: 14, color: "#fff", fontWeight: 700, cursor: "pointer" }}
                onClick={async () => {
                  try {
                    const res = await updateDivisionSettings(
                      user.branch_code,
                      user.division_code,
                      phoneInput,
                      sealImg || sealPreview || null
                    );
                    if (!res.success) { alert('❌ 저장 실패'); return; }
                    const updatedUser = {
                      ...user,
                      division_phone: phoneInput,
                      seal_img: sealImg || sealPreview || null
                    };
                    localStorage.setItem('user', JSON.stringify(updatedUser));
                    setShowPhoneModal(false);
                    alert('✅ 저장되었습니다.\n다음 로그인 시 반영됩니다.');
                  } catch (err) {
                    alert('❌ 저장 실패');
                  }
                }}>저장</button>
            </div>
          </div>
        </div>
      )}

      {/* 비밀번호 변경 모달 */}
      {showChangePw && (
        <ChangePasswordModal
          empNo={user.emp_no}
          onClose={() => setShowChangePw(false)}
          onSuccess={() => setShowChangePw(false)}
        />
      )}

      {/* 공지사항 팝업 */}
      {showNotice && notices.length > 0 && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.55)", zIndex: 300, display: "flex", alignItems: "center", justifyContent: "center" }}>
          <div style={{ background: "#fff", borderRadius: 20, width: "100%", maxWidth: 520, margin: "0 16px", boxShadow: "0 20px 60px rgba(0,0,0,0.35)", overflow: "hidden" }}>
            {/* 헤더 */}
            <div style={{ background: "linear-gradient(135deg, #1677ff, #4096ff)", padding: "20px 24px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div>
                <div style={{ fontSize: 11, color: "rgba(255,255,255,0.7)", marginBottom: 4 }}>
                  📢 공지사항 {noticeIdx + 1} / {notices.length}
                </div>
                <h3 style={{ fontSize: 16, fontWeight: 700, color: "#fff", margin: 0 }}>
                  {notices[noticeIdx].title}
                </h3>
              </div>
              <button style={{ background: "none", border: "none", color: "rgba(255,255,255,0.8)", fontSize: 20, cursor: "pointer" }}
                onClick={() => setShowNotice(false)}>✕</button>
            </div>

            {/* 이미지 */}
            {notices[noticeIdx].img_data && (
              <div style={{ padding: "20px 24px 0" }}>
                <img src={notices[noticeIdx].img_data} alt="공지이미지"
                  onClick={() => setImageZoom(notices[noticeIdx].img_data)}
                  style={{ width: "100%", maxHeight: 240, objectFit: "contain", cursor: "zoom-in", borderRadius: 8 }} />
              </div>
            )}

            {/* 내용 */}
            <div style={{ padding: "20px 24px", maxHeight: 200, overflowY: "auto" }}>
              <pre style={{ fontSize: 14, color: "#444", lineHeight: 1.8, whiteSpace: "pre-wrap", margin: 0, fontFamily: "'Noto Sans KR', sans-serif" }}>
                {notices[noticeIdx].content}
              </pre>
            </div>

            {/* 첨부파일 */}
            {notices[noticeIdx].files && notices[noticeIdx].files.length > 0 && (
              <div style={{ padding: "0 24px 12px" }}>
                {notices[noticeIdx].files.map(f => (
                  <a key={f.file_no}
                    href={resolveImageUrl(`/api/notice/${notices[noticeIdx].notice_year}/${notices[noticeIdx].seq_no}/files/${f.file_no}/download?branch_code=${notices[noticeIdx].branch_code}&division_code=${notices[noticeIdx].division_code}`)}
                    style={{ display: "flex", alignItems: "center", gap: 6, padding: "8px 12px", background: "#f0f7ff", borderRadius: 8, marginBottom: 6, fontSize: 13, color: "#1677ff", textDecoration: "none", fontWeight: 600 }}>
                    📎 {f.org_file_name}
                    <span style={{ color: "#aaa", fontWeight: 400, fontSize: 12 }}>
                      ({(f.file_size / 1024).toFixed(1)}KB)
                    </span>
                  </a>
                ))}
              </div>
            )}

            {/* 알림기간 */}
            <div style={{ padding: "0 24px 12px", fontSize: 12, color: "#aaa" }}>
              📅 {notices[noticeIdx].noti_start_dt} ~ {notices[noticeIdx].noti_end_dt}
            </div>

            {/* 하단 버튼 */}
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "14px 24px", borderTop: "1px solid #f0f0f0" }}>
              {/* 이전/다음 */}
              <div style={{ display: "flex", gap: 6 }}>
                <button
                  style={{ background: "#fff", border: "1px solid #e0e0e0", borderRadius: 8, padding: "6px 12px", fontSize: 13, color: "#666", cursor: noticeIdx > 0 ? "pointer" : "not-allowed", opacity: noticeIdx > 0 ? 1 : 0.4 }}
                  onClick={() => setNoticeIdx(p => Math.max(0, p - 1))}
                  disabled={noticeIdx === 0}>◀ 이전</button>
                <button
                  style={{ background: "#fff", border: "1px solid #e0e0e0", borderRadius: 8, padding: "6px 12px", fontSize: 13, color: "#666", cursor: noticeIdx < notices.length - 1 ? "pointer" : "not-allowed", opacity: noticeIdx < notices.length - 1 ? 1 : 0.4 }}
                  onClick={() => setNoticeIdx(p => Math.min(notices.length - 1, p + 1))}
                  disabled={noticeIdx === notices.length - 1}>다음 ▶</button>
              </div>
              <button
                style={{ background: "linear-gradient(135deg, #1677ff, #4096ff)", color: "#fff", border: "none", borderRadius: 8, padding: "8px 20px", fontSize: 14, fontWeight: 700, cursor: "pointer" }}
                onClick={async () => {
                  // 현재 공지 읽음 처리
                  const cur = notices[noticeIdx];
                  await markNoticeRead(cur.notice_year, cur.seq_no);

                  // 다음 공지가 있으면 이동, 없으면 닫기
                  if (noticeIdx < notices.length - 1) {
                    setNoticeIdx(p => p + 1);
                  } else {
                    setShowNotice(false);
                  }
                }}>확인</button>
            </div>
          </div>
        </div>
      )}

      {/* 공지 이미지 확대보기 */}
      {imageZoom && (
        <div
          style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.85)", zIndex: 400, display: "flex", alignItems: "center", justifyContent: "center", cursor: "zoom-out" }}
          onClick={() => setImageZoom(null)}
        >
          <button
            style={{ position: "absolute", top: 20, right: 24, background: "none", border: "none", color: "#fff", fontSize: 28, cursor: "pointer" }}
            onClick={() => setImageZoom(null)}
          >
            ✕
          </button>
          <img
            src={imageZoom}
            alt="공지이미지 원본"
            onClick={e => e.stopPropagation()}
            style={{ maxWidth: "92vw", maxHeight: "92vh", objectFit: "contain", borderRadius: 4 }}
          />
        </div>
      )}

      {/* 하단 footer */}
      <footer style={styles.footer}>
        <span>{divisionName}</span>
        {divisionPhone && <span style={{ margin: "0 8px", color: "#ccc" }}>|</span>}
        {divisionPhone && <span>📞 각종 문의 : {divisionPhone}</span>}
      </footer>
    </div>
  );
}

const styles = {
  wrap             : { minHeight: "100vh", background: "#f5f7fa", fontFamily: "'Noto Sans KR', sans-serif", overflowX: "hidden", display: "flex", flexDirection: "column" },
  header           : { background: "#1a1a2e", boxShadow: "0 2px 8px rgba(0,0,0,0.2)", position: "sticky", top: 0, zIndex: 100, overflowX: "hidden" },
  headerInner      : { maxWidth: 1200, margin: "0 auto", padding: "0 16px", height: 56, display: "flex", alignItems: "center", gap: 16, overflowX: "hidden" },
  footer           : { background: "#1a1a2e", color: "rgba(255,255,255,0.5)", fontSize: 12, textAlign: "center", padding: "14px 16px", marginTop: "auto" },
  logo             : { display: "flex", alignItems: "center", gap: 8, flexShrink: 0 },
  logoIcon         : { width: 52, height: 32, objectFit: "contain" },
  logoText         : { fontSize: 15, fontWeight: 800, color: "#fff", letterSpacing: "-0.5px" },
  nav              : { display: "flex", gap: 2, flex: 1, overflowX: "auto", scrollbarWidth: "none" },
  navScrollHide    : { scrollbarWidth: "none", msOverflowStyle: "none" },
  navBtn           : { background: "none", border: "none", padding: "8px 12px", borderRadius: 8, fontSize: 13, fontWeight: 500, color: "rgba(255,255,255,0.6)", cursor: "pointer", whiteSpace: "nowrap" },
  navBtnActive     : { background: "rgba(255,255,255,0.12)", color: "#fff", fontWeight: 700 },
  userArea         : { display: "flex", alignItems: "center", gap: 8, flexShrink: 0 },
  userName         : { fontSize: 12, color: "rgba(255,255,255,0.8)", whiteSpace: "nowrap" },
  adminBadge       : { background: "#c0392b", color: "#fff", fontSize: 10, fontWeight: 700, padding: "2px 6px", borderRadius: 10 },
  logoutBtn        : { background: "rgba(255,255,255,0.1)", border: "1px solid rgba(255,255,255,0.2)", borderRadius: 8, padding: "5px 10px", fontSize: 12, color: "rgba(255,255,255,0.8)", cursor: "pointer" },
  hamburger        : { background: "none", border: "none", color: "#fff", fontSize: 24, cursor: "pointer", padding: "0 4px", lineHeight: 1, flexShrink: 0 },
  mobileMenu       : { background: "#1a1a2e", borderTop: "1px solid rgba(255,255,255,0.1)", padding: "8px 16px 16px" },
  mobileMenuItem   : { display: "block", width: "100%", background: "none", border: "none", padding: "13px 16px", borderRadius: 8, fontSize: 15, fontWeight: 500, color: "rgba(255,255,255,0.7)", cursor: "pointer", textAlign: "left" },
  mobileMenuItemActive: { background: "rgba(255,255,255,0.12)", color: "#fff", fontWeight: 700 },
  mobileUserInfo   : { display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 8, paddingTop: 12, borderTop: "1px solid rgba(255,255,255,0.1)" },
  main             : { maxWidth: 1200, margin: "0 auto", width: "100%" },
};